import constants from '../constants';
import { elHasClass } from '../utils';

export default (dc, config = {}) => {
    const defaultType = dc.getType('default');
    const defaultModel = defaultType.model;
    const { wrapperName, slideSelector, containerSelector } = constants;

    dc.addType(wrapperName, {
        model: defaultModel.extend(
            {
                init() {
                    this.set({
                        name: 'Wrapper',
                        droppable: slideSelector,
                        draggable: containerSelector,
                        selectable: false,
                        ...config.wrapperProps,
                    });

                    const cls = config.classWrapper;
                    if (this.get('classes').pluck('name').indexOf(cls) < 0) {
                        this.addClass(cls);
                    }
                },
            },
            {
                isComponent(el) {
                    if (elHasClass(el, config.classWrapper))
                        return { type: wrapperName };
                },
            }
        ),

        view: defaultType.view.extend({
            init() {
                this.listenTo(
                    this.model.components(),
                    'add remove',
                    this.renderSlider
                );
            },

            renderSlider() {
                const slider = this.model.parent()?.parent();
                if (slider?.view) slider.view.render();
            },
        }),
    });
};
